import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { StandardModal } from 'shared/modal';
import Button from '../button';
import { Box, Flex, Grid } from '../grid';
import { Text } from '../typography';
import { ModalToastContext, OpenModalFn } from './context';

// type ShowModalFn

export const useGlobalModal = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeOnCleanupRefs = React.useRef(t0);
  const {
    openModal: openModal_
  } = React.useContext(ModalToastContext);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      closeOnCleanupRefs.current.forEach(_temp);
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] !== openModal_) {
    t3 = (title, getContent, options) => {
      const closeRef = {
        current: null
      };
      const onClose = () => {
        closeOnCleanupRefs.current = closeOnCleanupRefs.current.filter(v => v !== closeRef.current);
        options?.onClose?.();
      };
      const close_0 = openModal_(title, getContent, {
        ...options,
        onClose
      });
      closeRef.current = close_0;
      if (options?.closeWithHookCleanup == true) {
        closeOnCleanupRefs.current.push(close_0);
      }
      return close_0;
    };
    $[3] = openModal_;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const openModal = t3;
  return openModal;
};
const ConfirmModalContent = ({
  close,
  message,
  confirmButtonColor,
  confirmText,
  dismissText,
  leftOfButtons,
  onConfirm
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  return <Grid data-sentry-element="Grid" data-sentry-component="ConfirmModalContent" data-sentry-source-file="use-modal.tsx">
      <Text data-sentry-element="Text" data-sentry-source-file="use-modal.tsx">{message}</Text>
      <Flex justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="use-modal.tsx">
        <Box data-sentry-element="Box" data-sentry-source-file="use-modal.tsx"></Box>
        <Flex sx={{
        gap: 2
      }} mt={3} data-sentry-element="Flex" data-sentry-source-file="use-modal.tsx">
          {dismissText && <Button variant="flat" color="gray" onClick={close}>
              {dismissText || 'No'}
            </Button>}

          <Flex justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="use-modal.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="use-modal.tsx">{leftOfButtons}</Box>
            <Button color={confirmButtonColor} className="confirm-button" loading={isLoading} disabled={isLoading} onClick={async () => {
            const result = onConfirm();
            if (result?.then) {
              setIsLoading(true);
              try {
                await result;
                close();
              } catch (e) {
                console.error(e);
              } finally {
                setIsLoading(false);
              }
            } else {
              close();
            }
          }} data-sentry-element="Button" data-sentry-source-file="use-modal.tsx">
              {confirmText || 'Yes'}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Grid>;
};
export const useConfirmModal = () => {
  const $ = _c(2);
  const openModal = useGlobalModal();
  let t0;
  if ($[0] !== openModal) {
    t0 = t1 => {
      const {
        title,
        message,
        onConfirm: t2,
        confirmButtonColor: t3,
        confirmText: t4,
        dismissText: t5,
        leftOfButtons: t6
      } = t1;
      const onConfirm = t2 === undefined ? Promise.resolve : t2;
      const confirmButtonColor = t3 === undefined ? "primary" : t3;
      const confirmText = t4 === undefined ? "" : t4;
      const dismissText = t5 === undefined ? "" : t5;
      const leftOfButtons = t6 === undefined ? null : t6;
      return openModal(title, t7 => {
        const {
          close
        } = t7;
        return <ConfirmModalContent close={close} message={message} onConfirm={onConfirm} confirmButtonColor={confirmButtonColor} confirmText={confirmText} dismissText={dismissText} leftOfButtons={leftOfButtons} />;
      }, {
        size: "small",
        closeWithHookCleanup: true
      });
    };
    $[0] = openModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useConfirmModalLocal = () => {
  const $ = _c(5);
  const [modal, openModal] = useModal();
  let t0;
  if ($[0] !== openModal) {
    t0 = t1 => {
      const {
        title,
        message,
        onConfirm: t2,
        confirmButtonColor: t3,
        confirmText: t4,
        dismissText: t5,
        leftOfButtons: t6
      } = t1;
      const onConfirm = t2 === undefined ? Promise.resolve : t2;
      const confirmButtonColor = t3 === undefined ? "primary" : t3;
      const confirmText = t4 === undefined ? "" : t4;
      const dismissText = t5 === undefined ? "" : t5;
      const leftOfButtons = t6 === undefined ? null : t6;
      return openModal(title, t7 => {
        const {
          close
        } = t7;
        return <ConfirmModalContent close={close} message={message} onConfirm={onConfirm} confirmButtonColor={confirmButtonColor} confirmText={confirmText} dismissText={dismissText} leftOfButtons={leftOfButtons} />;
      }, "small");
    };
    $[0] = openModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== modal || $[3] !== t0) {
    t1 = [modal, t0];
    $[2] = modal;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1 as [React.JSX.Element | null, ({
    title,
    message,
    onConfirm,
    confirmButtonColor,
    confirmText,
    dismissText,
    leftOfButtons
  }: {
    title: string;
    message: string | any;
    onConfirm?: () => Promise<void>;
    confirmButtonColor?: string;
    confirmText?: string;
    dismissText?: string;
    leftOfButtons?: React.ReactNode;
  }) => void];
};
export default function useModal() {
  const $ = _c(11);
  const [modalContent, setModalContent] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setModalContent(null);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const close = t0;
  const t1 = modalContent !== null;
  const t2 = modalContent?.title;
  const t3 = modalContent?.content;
  let t4;
  if ($[1] !== t3) {
    t4 = {
      content: t3
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = modalContent?.size;
  let t6;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t4 || $[6] !== t5) {
    t6 = <StandardModal isOpen={t1} close={close} title={t2} props={t4} size={t5}>{_temp2}</StandardModal>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const modal = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = (title, getContent, size) => {
      setModalContent({
        size,
        content: getContent({
          close
        }),
        title
      });
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const showModal = t7;
  let t8;
  if ($[9] !== modal) {
    t8 = [modal, showModal, close];
    $[9] = modal;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}
function _temp2(t0) {
  const {
    content
  } = t0;
  return content;
}
function _temp(close) {
  return close();
}